import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import './reports-page.scss';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import moment from 'moment';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Button, Icons } from '../../../components/base/BootstrapComponents';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import DateTimePicker from '../../../components/fields/DatePicker/DateTimePicker';

export default function ReportsExportModal(props) {
  const tz = window.localStorage.getItem('USER_TIME_ZONE') || moment.tz.guess();
  const {
    control, getValues,
  } = useForm({
    defaultValues: {
      created_at_from: moment.tz(tz).subtract(1, 'months').toISOString(),
      created_at_to: moment.tz(tz).toISOString(),
    },
  });
  const { formatMessage } = useIntl();
  const { setShowExportModal = () => {}, handleExport = () => {} } = props;

  return (
    <Dialog
      className={classNames('report-export-modal')}
      onClose={() => setShowExportModal(false)}
      size="xl"
      open
    >
      <DialogTitle
        className="hff-title"
        title={(
          <>
            <div className="hff-title-text f2">{formatMessage({ id: 'rp.export.modal' })}</div>
            <div className="hff-close-wrapper">
              <Icons width={14} height={14} customIcon icon="clear" className="hff-close" onClick={() => setShowExportModal(false)} />
            </div>
          </>
              )}
      />
      <DialogContent className="hff-content">
        <FieldDTO
          control={control}
          type="text"
          component={DateTimePicker}
          withLabel
          dtoObject={{
            name: 'created_at_from',
            labelKey: 'rp.start_at',
          }}
          variant="material"
        />
        <FieldDTO
          control={control}
          type="text"
          component={DateTimePicker}
          withLabel
          dtoObject={{
            name: 'created_at_to',
            labelKey: 'rp.ended_at',
          }}
          variant="material"
        />
      </DialogContent>
      <DialogFooter>
        <Button onClick={() => handleExport({
          ...getValues(),
          export_type: 'session_payments',
        })}
        >Сформировать отчет
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
